import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HeadingsState {
    nodes: any[]
}


const initialState: HeadingsState = {
    nodes: []
}

const headingsSlice = createSlice({
    name: 'headings',
    initialState,
    reducers: {
        headingsSet: (state, action: PayloadAction<any[]>) => {
            state.nodes = action.payload;
        }
    }
})

export const { headingsSet } = headingsSlice.actions;

export default headingsSlice.reducer;